import dayjs, { type Dayjs } from 'dayjs';

import { IMyTicket } from '../../pages/ticketshop/types';

export type TMyTicketGroup = 'active' | 'cancelled' | 'passed';

/**
 * Decides which of the three Tickets-tab blocks a purchased ticket belongs to.
 * Active/preorder tickets go to the Ticketshop section, expired ones to the
 * Passed Trips. Cancelled and invalid tickets depend on where `now` sits inside
 * their validity window:
 * - `cancelled` stays in the Ticketshop section until `validFrom` is reached,
 *   then joins the Cancelled Trips;
 * - `invalid` stays in the Ticketshop section until `validUntil` is reached,
 *   then moves to the Passed Trips.
 * A ticket with a missing date counts as past its window (default fallback).
 *
 * `now` is injectable so the grouping can be unit-tested against fixed dates.
 */
export const getMyTicketGroup = (
	{ status, validFrom, validUntil }: IMyTicket,
	now: Dayjs = dayjs()
): TMyTicketGroup => {
	switch (status) {
		case 'active':
		case 'preorder':
			return 'active';
		case 'cancelled':
			return Boolean(validFrom) && now.isBefore(validFrom)
				? 'active'
				: 'cancelled';
		case 'invalid':
			return Boolean(validUntil) && now.isBefore(validUntil)
				? 'active'
				: 'passed';
		case 'expired':
			return 'passed';
		default:
			return 'active';
	}
};
